/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Support component names relative to this directory:

// Polyfills
import 'whatwg-fetch/fetch';
import 'promise-polyfill/src/polyfill';

// Third argument excludes all Storybook stories under __stories__ directories
var componentRequireContext = require.context("react", true, /^(?!.*__stories__\/.*$).*$/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
